<!--
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-12-07 15:09:38
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-12-11 13:36:22
-->
<!--  -->
<template>
  <div class="Card_box">
    <div class="Card" @click="clickCard()">
      <div>
        <div class="Card_state">{{ isOutIn }}</div>
        <div class="Card_time">{{ time }}</div>
      </div>
      <div>
        <div :class="isClass">
          <span>{{ isPositiveNega }}</span
          >{{ account }}元
        </div>
        <div class="Card_successful">{{ isSuccess }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: ['isStatus', 'time', 'isSuccess', 'account', 'data'],
  data() {
    return {};
  },
  computed: {
    isOutIn() {
      return this.isStatus ? '转入' : '转出';
    },
    isPositiveNega() {
      return this.isStatus ? '+' : '-';
    },
    isClass() {
      return this.isStatus ? 'Card_account_red' : 'Card_account_green';
    },
  },
  methods: {
    clickCard() {
      if (this.isStatus) {
        this.$router.push({
          path: '/supermarket/v2/DetailedfulTransfer',
          query: this.data,
        });
      } else {
        this.$router.push({
          path: '/supermarket/v2/DetailedTransferOut',
          query: this.data,
        });
      }
    },
  },
};
</script>
<style scoped>
.Card_box {
  background: #fff;
}
.Card {
  font-family: PingFangSC-Regular;
  background: #fff;
  width: 90%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 13px 0;
  border-bottom: 1px solid #dddee1;
}
.Card_state {
  text-align: left;
  font-size: 14px;
  color: #272f42;
  margin-bottom: 4px;
}
.Card_time {
  text-align: left;
  font-size: 12px;
  color: #b7bfd2;
}
.Card_account_red {
  text-align: right;
  font-size: 14px;
  margin-bottom: 4px;
  color: #ff6538;
}
.Card_account_green {
  text-align: right;
  font-size: 14px;
  margin-bottom: 4px;
  color: #40d970;
}
.Card_successful {
  text-align: right;
  font-size: 12px;
  color: #b7bfd2;
}
</style>
